import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./home.styl";
const template = require("./home.vue");

@Component({
  template: template
})
export class HomeComponent extends Vue {

}

Vue.component("cmHome", HomeComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/home/home.ts